/**
 * Formats a modifier group name for display.
 * If description exists and is not empty, returns "name (description)".
 * Otherwise, returns just the name.
 *
 * @param name - The modifier group name
 * @param description - The modifier group description (can be null, undefined, or empty string)
 * @returns The formatted display string
 */
export const formatModifierGroupDisplayName = (
  name: string,
  description?: string | null
): string => {
  if (description && description.trim() !== '') {
    return `${name} (${description})`
  }
  return name
}

